module.exports = __webpack_public_path__ + "img/image-icon.357630cb.svg";